import { loadBuiltFile, loadPage, splitRoutes } from './react'
import { clearPagesCache } from './react/cache'
import { Router } from './react/router'

declare let MAX_ROUTES: Record<string, string>
declare const maxDsl: any

export const router = Router()
export const loadResource = loadBuiltFile
export const getAllRoutes = splitRoutes
export { create, SubPage } from './react'
export const start = () => {
  loadBuiltFile('dist/routes.mjs').then(async () => {
    const defaultRoute = MAX_ROUTES['$default']
    // MEMO: 预览态当前使用iframe srcdoc路径，路由始终为srcdoc
    if (location.pathname === 'srcdoc') {
      router.navigateTo(defaultRoute)
      return
    }

    const url = location.pathname.substring(1)
    if (url) {
      const { created } = splitRoutes(url || defaultRoute)
      for (const route of created) {
        const pageCode = MAX_ROUTES[route]
        loadPage(pageCode)
      }
    } else {
      window.location.replace(`/${defaultRoute}${location.search}`)
    }
  })

  maxDsl.rootMax.onClearSubPageCache((route: string) => {
    clearPagesCache(route)
  })
}
